import React, { useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Button,
  Dialog,
  DialogContent,
  Box,
  Stack,
  TextField,
  Snackbar,
  Alert,
  DialogTitle,
  Typography,
  Grid,
} from "@mui/material";

function AltaProductoEnv(props) {
  const [alta, setAlta] = useState(props.alta);
  const [datosRow, setDatosRow] = useState({
    codigo: "",
    nombre: "",
    peso: "",
    abreviatura: "",
  });
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setAlta(!alta);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  const guardarProducto = async (e) => {
    e.preventDefault();
    await fetch(UrlApi + "/envasado_productos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        codigo: datosRow.codigo,
        nombre: datosRow.nombre,
        peso: datosRow.peso,
        abreviatura: datosRow.abreviatura,
        activo: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          console.log("Guardado");
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El Producto se guardó exitosamente !");
        } else {
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  return (
    <>
      <Dialog fullWidth open={alta} onClose={() => handleClose()} maxWidth="xl">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Producto Envasado
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={guardarProducto}>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={3} py={1} mb={1}>
                <TextField
                  label="Código"
                  name="codigo"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 100,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.codigo}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={9} py={1} mb={1}>
                <TextField
                  label="Nombre"
                  name="nombre"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 100,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.nombre}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <TextField
                  label="Peso"
                  name="peso"
                  size="small"
                  placeholder="..."
                  onKeyPress={(event) => {
                    if (!/[0-9.]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{
                    maxLength: 10,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.peso}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <TextField
                  label="Abreviatura"
                  name="abreviatura"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 45,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.abreviatura}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid>
                <Button type="submit" color="success" variant="contained">
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AltaProductoEnv;
